import { render, staticRenderFns } from "./TimeRecommendDialog.vue?vue&type=template&id=0c6762e4&scoped=true"
import script from "./TimeRecommendDialog.vue?vue&type=script&lang=js"
export * from "./TimeRecommendDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6762e4",
  null
  
)

export default component.exports